import React from 'react';

const TickTarget = () => {
	return (
		<svg
			width="80"
			height="80"
			viewBox="0 0 80 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_5_310)">
				<path
					d="M57.5003 19.9988H21.4996C20.6708 19.9988 19.9988 20.6708 19.9988 21.4996V57.5003C19.9988 57.8971 20.1556 58.2811 20.4372 58.5627C20.7188 58.8443 21.0996 59.0011 21.4996 59.0011H57.5003C57.8971 59.0011 58.2811 58.8443 58.5627 58.5627C58.8443 58.2811 59.0011 57.9003 59.0011 57.5003V21.4996C59.0011 21.1028 58.8443 20.7188 58.5627 20.4372C58.2811 20.1556 57.9003 19.9988 57.5003 19.9988ZM55.9995 55.9995H23.0004V23.0004H55.9995V55.9995Z"
					fill="#12D231"
				/>
				<path
					d="M47.177 32.1399C46.7001 32.1559 46.2457 32.3575 45.9129 32.7031C42.3929 36.2295 39.7048 39.1768 36.4375 42.5113L32.9559 39.5704C32.5847 39.2568 32.1015 39.1032 31.615 39.1416C31.1286 39.1832 30.6774 39.4168 30.3638 39.7912C30.0502 40.1656 29.8966 40.6488 29.9382 41.1352C29.9798 41.6216 30.2166 42.0729 30.591 42.3833L35.3687 46.4249C36.0983 47.0393 37.1736 46.9945 37.8488 46.3225C41.8072 42.3545 44.6265 39.1864 48.5082 35.2951C49.0522 34.7671 49.2218 33.9607 48.9242 33.2599C48.6298 32.5591 47.9354 32.1143 47.177 32.1367V32.1399ZM78.5024 37.9992H74.0031V6.50095C74.0031 6.10414 73.8463 5.72013 73.5647 5.43853C73.2831 5.15692 72.9023 5.00012 72.5023 5.00012H41.0008V0.50083C41.0008 -0.327987 40.3288 -1 39.5 -1C38.6712 -1 37.9992 -0.327987 37.9992 0.50083V5.00012H6.50095C5.67213 5.00012 5.00012 5.67213 5.00012 6.50095V38.0024H0.50083C-0.327987 38.0024 -1 38.6744 -1 39.5032C-1 40.332 -0.327987 41.004 0.50083 41.004H5.00012V72.5054C5.00012 72.9023 5.15692 73.2863 5.43853 73.5679C5.72013 73.8495 6.10094 74.0063 6.50095 74.0063H38.0024V78.5056C38.0024 79.3344 38.6744 80.0064 39.5032 80.0064C40.332 80.0064 41.004 79.3344 41.004 78.5056V74.0063H72.5054C72.9023 74.0063 73.2863 73.8495 73.5679 73.5679C73.8495 73.2863 74.0063 72.9055 74.0063 72.5054V41.004H78.5056C79.3344 41.004 80.0064 40.332 80.0064 39.5032C80.0064 38.6744 79.3344 38.0024 78.5056 38.0024L78.5024 37.9992ZM71.0014 71.0014H41.0008V66.5021C41.0008 65.6733 40.3288 65.0013 39.5 65.0013C38.6712 65.0013 37.9992 65.6733 37.9992 66.5021V71.0014H7.99858V41.0008H12.4979C13.3267 41.0008 13.9987 40.3288 13.9987 39.5C13.9987 38.6712 13.3267 37.9992 12.4979 37.9992H7.99858V7.99858H37.9992V12.4979C37.9992 13.3267 38.6712 13.9987 39.5 13.9987C40.3288 13.9987 41.0008 13.3267 41.0008 12.4979V7.99858H71.0014V37.9992H66.5021C65.6733 37.9992 65.0013 38.6712 65.0013 39.5C65.0013 40.3288 65.6733 41.0008 66.5021 41.0008H71.0014V71.0014Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5_310">
					<rect
						width="81"
						height="81"
						fill="white"
						transform="translate(-1 -1)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default TickTarget;
